import { Route } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { authGuard } from './features/auth/guards/auth.guard';

import { noAuthGuard } from './features/auth/guards/no-auth-guard.guard';
import { AccountVerifiedComponent } from './features/auth/set-new-password/account-verified/account-verified.component';
import { VerificationFailedComponent } from './features/auth/set-new-password/verification-failed/verification-failed.component';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { roleGuard } from './features/auth/guards/role.guard';
import { defaultRouteGuard } from './features/auth/guards/defaultRoute.guard';
const userTypeIs =
  (...roles: string[]) =>
  () =>
    roles.includes(localStorage.getItem('userType') ?? '');
export const appRoutes: Route[] = [
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [noAuthGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then(
            (c) => c.LoginComponent
          ),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import(
            './features/auth/forget-password/forget-password.component'
          ).then((c) => c.ForgetPasswordComponent),
      },
      {
        path: 'verify-otp',
        loadComponent: () =>
          import('./features/auth/verify-otp/verify-otp.component').then(
            (c) => c.VerifyOTPComponent
          ),
      },
      {
        path: 'set-password',
        loadComponent: () =>
          import(
            './features/auth/set-new-password/set-new-password/set-new-password.component'
          ).then((c) => c.SetNewPasswordComponent),
      },
      {
        path: 'password-changed',
        loadComponent: () =>
          import(
            './features/auth/password-changed-success/password-changed-success/password-changed-success.component'
          ).then((c) => c.PasswordChangedSuccessComponent),
      },
    ],
  },
  // },
  // {
  //   path: 'login',
  //   component: LoginComponent,
  //   canActivate: [noAuthGuard],
  // },
  // {
  //   path: 'set-password',
  //   component: SetNewPasswordComponent,
  // },
  // {
  //   path: 'forget-password',
  //   component: ForgetPasswordComponent,
  //   canActivate: [noAuthGuard],
  // },
  // {
  //   path: 'password-changed',
  //   component: PasswordChangedSuccessComponent,
  //   canActivate: [noAuthGuard],
  // },
  // {
  //   path: 'verify-otp',
  //   component: VerifyOTPComponent,
  // },

  // example for role guard usage
  // {
  //   path: 'set-password',

  //   canActivate: [authGuard, roleGuard],
  //   data: {
  //     roles: ['app_admin'],
  //   },
  //   loadComponent: () =>
  //     import(
  //       './features/auth/set-new-password/set-new-password/set-new-password.component'
  //     ).then((m) => m.SetNewPasswordComponent),
  // },
  {
    path: 'account-verified',
    component: AccountVerifiedComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'verification-failed',
    component: VerificationFailedComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'dashboard',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        canMatch: [userTypeIs('app_admin')],
        // canMatch: [() => localStorage.getItem('userType') === 'app_admin'],
        loadComponent: () =>
          import(
            './features/dashboard/application-admin-dashboard/application-admin-dashboard.component'
          ).then((m) => m.ApplicationAdminDashboardComponent),
      },
      {
        path: '',
        pathMatch: 'full',
        canMatch: [userTypeIs('components_admin')],
        loadComponent: () =>
          import(
            './features/dashboard/user-dashboard/user-dashboard.component'
          ).then((m) => m.UserDashboardComponent),
      },
      {
        path: '',
        pathMatch: 'full',
        canMatch: [userTypeIs('application_user')],
        loadComponent: () =>
          import(
            './features/dashboard/user-dashboard/user-dashboard.component'
          ).then((m) => m.UserDashboardComponent),
      },
      // {
      //   path: '',
      //   pathMatch: 'full',
      //   redirectTo: 'api-test',
      // },
      {
        path: 'api-test',
        loadComponent: () =>
          import('./features/api-test/api-test.component').then(
            (m) => m.ApiTestComponent
          ),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['application_user', 'components_admin'] },
      },
      {
        path: 'api-standards',
        loadComponent: () =>
          import(
            './features/api-standards/api-standard-list/api-standard-list.component'
          ).then((m) => m.ApiStandardListComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['app_admin'] },
      },
      {
        path: 'api-standards/add-standard',
        loadComponent: () =>
          import(
            './features/api-standards/api-standard-form/api-standard-form.component'
          ).then((m) => m.ApiStandardFormComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['app_admin'] },
      },
      {
        path: 'api-standards/edit-standard',
        loadComponent: () =>
          import(
            './features/api-standards/api-standard-form/api-standard-form.component'
          ).then((m) => m.ApiStandardFormComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['app_admin'] },
      },
      // {
      //   path: 'api-history',
      //   loadComponent: () =>
      //     import('./features/history-apis/history-apis.component').then(
      //       (m) => m.HistoryApisComponent
      //     ),
      //   canActivate: [authGuard, roleGuard],
      //   data: {
      //     roles: ['application_user'],
      //   },
      // },
      {
        path: 'api-history',
        loadComponent: () =>
          import('./features/history/history.component').then(
            (m) => m.HistoryComponent
          ),
        canActivate: [authGuard, roleGuard],
        data: {
          roles: ['application_user', 'components_admin'],
        },
      },
      {
        path: 'api-standards/view-standard/:id',
        loadComponent: () =>
          import(
            './features/api-standards/api-standard-details/api-standard-details.component'
          ).then((m) => m.ApiStandardDetailsComponent),
        canActivate: [authGuard, roleGuard],
        data: {
          roles: ['app_admin'],
        },
      },
      {
        path: 'user-management',
        loadComponent: () =>
          import(
            './features/user-management/user-management-list/user-management-list.component'
          ).then((m) => m.UserManagementListComponent),
        canActivate: [authGuard, roleGuard],
        data: {
          roles: ['app_admin'],
        },
      },
      {
        path: 'repository',
        loadComponent: () =>
          import(
            './features/repository/repository-list/repository-list.component'
          ).then((m) => m.RepositoryListComponent),
        canActivate: [authGuard, roleGuard],
        data: {
          roles: ['components_admin', 'application_user'],
        },
      },
      {
        path: 'audit-trail',
        loadComponent: () =>
          import(
            './features/audit-trail/audit-trail-list/audit-trail-list.component'
          ).then((m) => m.AuditTrailListComponent),
        canActivate: [authGuard, roleGuard],
        data: {
          roles: ['app_admin'],
        },
      },
      // {
      //   path: '',
      //   pathMatch: 'full',
      //   redirectTo: 'api-test',
      // },
      // {
      //   path: 'api-test',
      //   loadComponent: () =>
      //     import('./features/api-test/api-test.component').then(
      //       (m) => m.ApiTestComponent
      //     ),
      //   // canActivate: [authGuard, roleGuard],
      //   // data: {
      //   //   roles: ['application_user'],
      //   // },
      // },
      // {
      //   path: 'api-history',
      //   loadComponent: () =>
      //     import('./features/history-apis/history-apis.component').then(
      //       (m) => m.HistoryApisComponent
      //     ),
      //   canActivate: [authGuard, roleGuard],
      //   data: {
      //     roles: ['application_user'],
      //   },
      // },
      // {
      //   path: 'api-standard-list',
      //   loadComponent: () =>
      //     import(
      //       './features/api-standards/api-standard-list/api-standard-list.component'
      //     ).then((m) => m.ApiStandardListComponent),
      //   canActivate: [authGuard, roleGuard],
      //   data: {
      //     roles: ['app_admin'],
      //   },
      // },
      // ...[
      //   'api-standard-list/edit-standard',
      //   'api-standard-list/add-standard',
      // ].map((path) => ({
      //   path,
      //   loadComponent: () =>
      //     import(
      //       './features/api-standards/api-standard-form/api-standard-form.component'
      //     ).then((m) => m.ApiStandardFormComponent),
      // })),
      // {
      //   path: 'api-standard-list/view-standard',
      //   loadComponent: () =>
      //     import(
      //       './features/api-standards/api-standard-details/api-standard-details.component'
      //     ).then((m) => m.ApiStandardDetailsComponent),
      // },
      // {
      //   path: 'activity-monitoring',
      //   loadComponent: () =>
      //     import(
      //       './features/activity-monitoring/activity-monitoring-list/activity-monitoring-list.component'
      //     ).then((m) => m.ActivityMonitoringListComponent),
      // },

      // {
      //   path: 'user-management',
      //   loadComponent: () =>
      //     import(
      //       './features/user-management/user-management-list/user-management-list.component'
      //     ).then((m) => m.UserManagementListComponent),
      //   canActivate: [authGuard, roleGuard],
      //   data: {
      //     roles: ['app_admin'],
      //   },
      // },
      // {
      //   path: 'settings',
      //   loadComponent: () =>
      //     import('./features/settings/settings.component').then(
      //       (m) => m.SettingsComponent
      //     ),
      // },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
